module.exports = __webpack_public_path__ + "media/images/office_3-36b14a4205d77edd88240bbeec8aa773.jpg";